import { useEffect } from 'react'

import isEqual from 'lodash/isEqual'
import usePrevious from '../../common/usePrevious'
import { sendUserData } from '../../../analyticsHelpers'

export const useSendUserData = currentUser => {
  const prevUser = usePrevious(currentUser)

  useEffect(() => {
    if (!isEqual(prevUser, currentUser)) {
      sendUserData(currentUser)
    }
  }, [prevUser, currentUser])
}



// WEBPACK FOOTER //
// ./src/utils/hooks/fullstory/useSendUserData/index.js